import React from 'react';
import { useFormContext } from 'react-hook-form';
import customConfirmAlert from '../../../../../../ConfirmAlert';
import styles from './index.module.scss';
import useMixpanel from '../../../../../../../hooks/useMixpanel';
import CancelAction from '../../../OnBoardingDrawerAction/CancelAction';
import useQueryParam from '../../../../../../../hooks/useCustomQueryParam';

const EditPatientCancelAction = () => {
  const { trackClick } = useMixpanel();
  const {
    formState: { isDirty },
  } = useFormContext();
  const [, setNewPatient] = useQueryParam<string | undefined>('newPatientUuid');

  const closeDrawer = () => {
    setNewPatient(undefined);
  };

  const cancelRegistration = () => {
    trackClick({
      action: 'exit_patient_registration',
    });
    closeDrawer();
  };

  const onCancel = () => {
    if (isDirty) {
      customConfirmAlert({
        title: 'Cancel Registration',
        body: 'Are you sure you want to cancel the patient registration process?',
        label: 'Cancel',
        cancelText: 'Continue Registration',
        onClick: () => cancelRegistration(),
        classes: {
          overlay: styles.patientConfirmOverlay,
          body: styles.body,
        },
      });
    } else {
      closeDrawer();
    }
  };

  return <CancelAction onClick={onCancel} />;
};

export default EditPatientCancelAction;
